//文字コードはutf-8

/**
 * トップページの固定リンク表示制御
 * スクロール位置に応じて表示/非表示を切り替える
 * フッターの上に来たら非表示にする
 */
export function initTopFixedLinks() {
  const fixedLinks = document.querySelector('.topFixedLinks');
  const footer = document.querySelector('.footer');
  
  if (!fixedLinks) {
    return;
  }
  
  // 表示開始位置（スクロール量）
  const showScrollThreshold = 30;
  
  /**
   * スクロール位置に応じて表示/非表示を切り替える
   */
  function updateFixedLinksVisibility() {
    const scrollY = window.scrollY || window.pageYOffset;
    
    // スクロール位置が閾値未満の場合は非表示
    if (scrollY < showScrollThreshold) {
      fixedLinks.classList.remove('is-visible');
      return;
    }
    
    // フッターが存在する場合、フッターの上に来たら非表示
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      const footerTop = footerRect.top + window.scrollY;
      const viewportHeight = window.innerHeight;
      const scrollBottom = scrollY + viewportHeight;
      
      // フッターの上端がビューポート内に入ったら非表示
      if (scrollBottom >= footerTop) {
        fixedLinks.classList.remove('is-visible');
        return;
      }
    }
    
    // 上記の条件に該当しない場合は表示
    fixedLinks.classList.add('is-visible');
  }
  
  // 初回実行
  updateFixedLinksVisibility();
  
  // スクロール時に実行（パフォーマンスのためrequestAnimationFrameを使用）
  let ticking = false;
  
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateFixedLinksVisibility();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // リサイズ時にも実行
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateFixedLinksVisibility, 100);
  });
}

